// Menu tracking: which menu points customers use.
// Sends Shopify customer events ("menu_*"); the "Search widget GA4" custom pixel forwards them to GA4.
// Listens on the document only, so the menu files themselves stay untouched.
(function () {
  if (window.SKMenuTracking) return;
  window.SKMenuTracking = true;

  var DESKTOP = window.matchMedia("(min-width: 880px)");

  function track(name, data) {
    try {
      if (!window.Shopify || !Shopify.analytics || !Shopify.analytics.publish) return;
      data.device = DESKTOP.matches ? "desktop" : "mobile";
      Shopify.analytics.publish("menu_" + name, data);
    } catch (err) {}
  }

  function clean(text) {
    return (text || "").replace(/\(\s*\d+\s*\)/, "").replace(/\s+/g, " ").trim().slice(0, 100);
  }

  // Title of the submenu a link sits in ("" on the first page of the menu)
  function slideTitle(el) {
    var slide = el.closest(".slide--mobile_menu");
    return slide ? slide.getAttribute("data-slide") || "" : "";
  }

  function positionIn(el, selector) {
    var item = el.closest(selector);
    if (!item || !item.parentElement) return 0;
    return Array.from(item.parentElement.children).filter(function (c) {
      return c.matches(selector);
    }).indexOf(item) + 1;
  }

  // Mobile menu link: where in the menu it sits
  function mobileLink(a) {
    var dropdown = a.closest("wdn-dropdown");
    var dropdownTitle = dropdown && dropdown.querySelector("[dropdown-trigger] .mobile_menu-text");
    var level = "main";
    if (a.closest(".slide--mobile_menu-country")) level = "country";
    else if (a.closest(".menu-post-slider")) level = "post";
    else if (dropdown) level = "accordion";
    else if (a.closest(".slide--mobile_menu")) level = "submenu";
    var title = a.querySelector(".menu-post-title") || a.closest(".menu-post") && a.closest(".menu-post").querySelector(".menu-post-title");
    return {
      menu: "mobile",
      item_title: clean(title ? title.textContent : a.textContent),
      item_url: (a.getAttribute("href") || "").split("?")[0],
      level: level,
      submenu: slideTitle(a),
      parent_title: dropdownTitle ? clean(dropdownTitle.textContent) : "",
      position: positionIn(a, ".mobile_menu-item"),
    };
  }

  // Desktop header + mega menu link
  function desktopLink(a) {
    var group = a.closest("[data-megamenu-group]");
    var level = "top";
    if (a.closest(".menu-post-slider, .menu-features")) level = "feature";
    else if (a.closest(".menu-group-grandchild")) level = "grandchild";
    else if (a.closest(".menu-group-child")) level = "child";
    return {
      menu: "desktop",
      item_title: clean(a.textContent),
      item_url: (a.getAttribute("href") || "").split("?")[0],
      level: level,
      submenu: group ? group.getAttribute("data-megamenu-group") || "" : "",
      parent_title: "",
      position: level === "top" ? positionIn(a, ".header-link") : 0,
    };
  }

  // Opening the menu: header burger or tab bar
  document.addEventListener(
    "click",
    function (e) {
      if (!e.target.closest) return;
      if (e.target.closest("[data-tab-action='menu']")) {
        track("open", { trigger: "tab_bar" });
      } else if (e.isTrusted && e.target.closest("wdn-drawer-open[data-id='menu']")) {
        track("open", { trigger: "header" });
      }
    },
    true
  );

  // Bubble phase: the menu's own handlers (submenus, cart, country) have already run
  document.addEventListener("click", function (e) {
    if (!e.target.closest) return;
    var inMobile = e.target.closest(".mobile_menu, .slide--mobile_menu");
    var inDesktop = !inMobile && e.target.closest(".header-links, [data-megamenu-group]");
    if (!inMobile && !inDesktop) return;

    // Row that opens a submenu
    var slide = inMobile && e.target.closest("[data-slide-to]");
    if (slide) {
      var to = slide.getAttribute("data-slide-to");
      if (to && to !== "back") {
        track("submenu_open", { item_title: clean(slide.textContent).replace(/:.*/, ""), submenu: to, position: positionIn(slide, ".mobile_menu-item") });
      }
      return;
    }

    // Accordion row (opened, not closed)
    var trigger = inMobile && e.target.closest("[dropdown-trigger]");
    if (trigger) {
      var dropdown = trigger.closest("wdn-dropdown");
      setTimeout(function () {
        if (dropdown && dropdown.isActive) {
          track("accordion_open", { item_title: clean(trigger.textContent), submenu: slideTitle(trigger) });
        }
      }, 0);
      return;
    }

    var a = e.target.closest("a[href]");
    if (!a) return;
    var href = a.getAttribute("href") || "";
    if (!href || href.charAt(0) === "#") return;

    track("click", inMobile ? mobileLink(a) : desktopLink(a));

    // Give the event a moment to leave before the page changes (plain left clicks the menu didn't handle)
    if (!e.defaultPrevented && e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && a.target !== "_blank") {
      e.preventDefault();
      setTimeout(function () {
        window.location.href = a.href;
      }, 150);
    }
  });
})();
